import { useQuery } from '@tanstack/react-query';
import React from 'react'
import { useHistory, useParams } from 'react-router-dom';
import api from 'services/api';
import { IResponse } from './AppInclusion.types';
import { IconButton, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { AppInclusionTable } from './AppInclusion.Table';

export function AppInclusionView() {
  const { workspaceId, templateId, workspaceActivityId } = useParams() as { workspaceId: string, templateId: string, workspaceActivityId: string; };
  const history = useHistory();

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["app_edit_data", workspaceActivityId],
    queryFn: () => api.get<{ data: IResponse }>(`/v2/apps/inclusion/${workspaceActivityId}`),
    select: (data) => data.data.data,
    refetchInterval: 5000,
  });
  
  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && (
        <>
          <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center" }}>
            <IconButton
              size="small"
              onClick={() => history.push(`/v2/workspaces/${workspaceId}/templates/${templateId}/movements-check`)}
            >
              <ArrowBack color="primary" />
            </IconButton>
            <Typography variant="h6">Inclusões</Typography>
          </div>
          <AppInclusionTable people={data.people} config={data.config} />
        </>
      )}
    </>
  )
}
